// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3b788ddb] .has-small-text{font-size:.825rem}", "",{"version":3,"sources":["webpack://./resources/client/components/table/TableDefault.vue"],"names":[],"mappings":"AAEA,kCACE,iBADF","sourcesContent":["\n\n::v-deep(.has-small-text) {\n  font-size: 0.825rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
